<template>
    <div class="page-course">
        <vue-headful 
            :title="$PPlusEngine.getDictionary($route.params.lang, 
                'บทเรียนทั้งหมด - ProbPlus', 
                'All Modules - ProbPlus')" 
            :description="$PPlusEngine.getDictionary($route.params.lang, 
                'เปิดโลกรู้เท่าทันการฟอกเงินด้วยหลักสูตรซึ่งได้รับการรับรองจากสำนักงานปปง.กับพวกเรา ProbPlus', 
                'เปิดโลกรู้เท่าทันการฟอกเงินด้วยหลักสูตรซึ่งได้รับการรับรองจากสำนักงานปปง.กับพวกเรา ProbPlus')" />
        <ContentLoader :isDisplay="!contentReady" />
        <template v-if="contentReady">
            <section class="top-title">
                <div class="container">
                    <h1>{{ $PPlusEngine.getDictionary($route.params.lang, 'บทเรียนทั้งหมด', 'All Modules') }}</h1>
                </div>
            </section>
            <section class="course">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 col-lg-4" v-for="(item, index) in fields" :key="index">
                            <CourseBox :fields="item" />
                        </div>
                    </div>
                </div>
            </section>
            <ExamLink />
        </template>
    </div>
</template>

<script>
import ContentLoader from '@/weact/components/ContentLoader';
import CourseBox from '@/components/CourseBox';
import ExamLink from '@/components/ExamLink';

export default {
    components: {
        ContentLoader,
        CourseBox,
        ExamLink
    },
    data() {
        return {
            contentReady: false,
            fields: {}
        }
    },
    created() {
        let page = this;
        
        setTimeout(function(){
            page.getContent();
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        getContent() {
            let apiURL = this.$PPlusConfig.ApiURL;
            let postData = {
                langCode: this.$route.params.lang
            };

            this.$WeHelper.postAPI(apiURL, '/api/course/get-course-list', postData).then((response) => {
                this.fields = response.data;
                this.contentReady = true;
            });
        }
    }
};
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-course {
    .top-title {
        background-image: url(../assets/course-bg.jpg);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        display: flex;
        align-items: center;
        width: 100%;
        height: 200px;

        h1 {
            margin: 0;
            font-size: 48px;
            font-weight: 200;
            color: #fff;
            text-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
            text-align: center;
        }
    }

    .course {
        padding: 40px 0 50px;
    }
}
</style>